export default {
  computed: {
    lokakarya2024() {
      let instrumens = [];
      for (const key of this.keyInstrumen.split('|')) {
        instrumens = instrumens.concat(this.instrumens[key] || []);
      }

      if (this.keyInstrumen.split('|').includes('ds24-lokakarya')) {
        instrumens.push({
          type: 'VTextField',
          name: 'rencana_url',
          label:
            'Rencana aksi nyata peserta lokakarya (inputkan link google drive yang berisi dokumen rencana aksi nyata)',
          labelColor: 'indigo',
          hint: '',
          customClass: 'mt-0',
          grid: { cols: 12, md: 12, sm: 12 },
          outlined: true,
          singleLine: true,
          dense: true,
          hideDetails: true,
          readonly: this.readonly,
          prependInnerIcon: 'mdi-video',
        });
      }

      return {
        pelapor: [
          {
            type: 'textView',
            label: 'Nama Kegiatan',
            labelColor: 'indigo',
            bgColor: 'grey lighten-3 pa-2 mb-4',
            value: this.$getDeepObj(this.meta, `lokakarya_kegiatan.${this.kKegiatan}.0`) || '',
            grid: { cols: 12, md: 6 },
          },
          {
            type: 'textView',
            label: 'Nama Fasilitator',
            labelColor: 'indigo',
            bgColor: 'grey lighten-3 pa-2 mb-4',
            value: this.detail.pelapor || this.ptk.nama,
            grid: { cols: 12, md: 6 },
          },
        ],
        tipePelapor: true,
        pelaksanaan: [
          {
            type: 'VDatePicker',
            name: 'tgl_pelaksanaan',
            label: 'Waktu Pelaksanaan',
            labelColor: 'indigo',
            usePrependInnerIcon: 'mdi-calendar-month',
            hint: 'wajib diisi',
            required: true,
            outlined: true,
            singleLine: true,
            disabled: this.readOnly,
            hideDetails: true,
            dense: true,
            grid: { cols: 12, md: 6, sm: 12 },
          },
          {
            type: 'VTextField',
            name: 'lokasi',
            label: 'Tempat Pelaksanaan',
            labelColor: 'indigo',
            hint: 'wajib diisi',
            outlined: true,
            singleLine: true,
            readonly: this.readOnly,
            hideDetails: true,
            dense: true,
            rules: { required: true, maxChar: 250 },
            grid: { cols: 12, md: 6, sm: 12 },
          },
          {
            type: 'VSelect',
            name: 'k_lokakarya_moda_psp',
            label: 'Moda yang diterapkan',
            labelColor: 'indigo',
            hint: 'wajib diisi',
            items: this.$mapForMaster(this.mModaLokakarya),
            required: true,
            outlined: true,
            singleLine: true,
            readonly: this.readOnly,
            dense: true,
            grid: { cols: 12, md: 6, sm: 12 },
          },
          {
            type: 'textView',
            label: 'Durasi (JP)',
            labelColor: 'indigo',
            bgColor: 'grey lighten-3 pa-2 mb-4',
            value: `${this.$getDeepObj(this.meta, `lokakarya_kegiatan.${this.kKegiatan}.4`) || ''} JP`,
            grid: { cols: 12, md: 6 },
          },
        ],
        peserta: [
          {
            type: 'VTextField',
            name: 'jml_kasek',
            label: 'Jumlah Peserta KS yang Hadir',
            labelColor: this.isNotEmpty && !this.form.jml_kasek && this.form.jml_kasek !== 0 ? 'red' : 'indigo',
            hint: '',
            mask: '###',
            required: false,
            outlined: true,
            singleLine: true,
            hideDetails: true,
            dense: true,
            readonly: this.readOnly,
            grid: { cols: 12, md: 3, sm: 12 },
          },
          {
            type: 'VTextField',
            name: 'jml_kasek_sasaran',
            label: 'Jumlah Peserta KS yang Seharusnya',
            labelColor:
              this.isNotEmpty && !this.form.jml_kasek_sasaran && this.form.jml_kasek_sasaran !== 0 ? 'red' : 'indigo',
            hint: '',
            mask: '###',
            required: false,
            outlined: true,
            singleLine: true,
            hideDetails: true,
            dense: true,
            readonly: this.readOnly,
            grid: { cols: 12, md: 3, sm: 12 },
          },
          {
            type: 'VTextField',
            name: 'jml_guru',
            label: 'Jumlah Peserta Guru yang Hadir',
            labelColor: this.isNotEmpty && !this.form.jml_guru && this.form.jml_guru !== 0 ? 'red' : 'indigo',
            hint: '',
            mask: '###',
            required: false,
            outlined: true,
            singleLine: true,
            hideDetails: true,
            dense: true,
            readonly: this.readOnly,
            grid: { cols: 12, md: 3, sm: 12 },
          },
          {
            type: 'VTextField',
            name: 'jml_guru_sasaran',
            label: 'Jumlah Peserta Guru yang Seharusnya',
            labelColor:
              this.isNotEmpty && !this.form.jml_guru_sasaran && this.form.jml_guru_sasaran !== 0 ? 'red' : 'indigo',
            hint: '',
            mask: '###',
            required: false,
            outlined: true,
            singleLine: true,
            hideDetails: true,
            dense: true,
            readonly: this.readOnly,
            grid: { cols: 12, md: 3, sm: 12 },
          },
          {
            type: 'VTextField',
            name: 'jml_pengawas',
            label: 'Jumlah Peserta PS yang Hadir',
            labelColor: this.isNotEmpty && !this.form.jml_pengawas && this.form.jml_pengawas !== 0 ? 'red' : 'indigo',
            hint: '',
            mask: '###',
            required: false,
            outlined: true,
            singleLine: true,
            hideDetails: true,
            dense: true,
            readonly: this.readOnly,
            grid: { cols: 12, md: 3, sm: 12 },
          },
          {
            type: 'VTextField',
            name: 'jml_pengawas_sasaran',
            label: 'Jumlah Peserta PS yang Seharusnya',
            labelColor:
              this.isNotEmpty && !this.form.jml_pengawas_sasaran && this.form.jml_pengawas_sasaran !== 0
                ? 'red'
                : 'indigo',
            hint: '',
            mask: '###',
            required: false,
            outlined: true,
            singleLine: true,
            hideDetails: true,
            dense: true,
            readonly: this.readOnly,
            grid: { cols: 12, md: 3, sm: 12 },
          },
        ],
        instrumens,
        berkas: [
          {
            kBerkas: 1,
            key: 'presensi-peserta',
            label: 'daftar hadir Peserta',
            berkases: this.lokakaryaBerkases.filter((s) => Number(s.k_lokakarya_berkas_psp) === 1) || [],
          },
          {
            kBerkas: 2,
            key: 'presensi-fasilitator',
            label: 'daftar hadir Fasilitator',
            berkases: this.lokakaryaBerkases.filter((s) => Number(s.k_lokakarya_berkas_psp) === 2) || [],
          },
          {
            kBerkas: 3,
            key: 'bukti-fisik',
            label: [38, 58].includes(+this.kKegiatan)
              ? 'Bukti Fisik Dokumen yang Relevan (tautan hasil sesi refleksi dan berbagi praktik baik; tautan hasil rencana dan tindak lanjut)'
              : 'bukti fisik dokumen yang relevan (jika ada)',
            berkases: this.lokakaryaBerkases.filter((s) => Number(s.k_lokakarya_berkas_psp) === 3) || [],
          },
          {
            kBerkas: 6,
            key: 'dokumentasi',
            label: 'dokumentasi kegiatan',
            desc: 'Sematkan minimal 2 Foto Dokumentasi dan maksimal 5 foto.',
            berkases: this.lokakaryaBerkases.filter((s) => Number(s.k_lokakarya_berkas_psp) === 6) || [],
          },
          {
            kBerkas: this.keyInstrumen === 'ds24-refleksi-ps' ? 7 : false,
            key: this.keyInstrumen === 'ds24-refleksi-ps' ? 'rencana' : '',
            label: 'Dokumen Rencana Tindak Lanjut Peserta',
            berkases: this.lokakaryaBerkases.filter((s) => Number(s.k_lokakarya_berkas_psp) === 7) || [],
          },
          {
            kBerkas: 9,
            max: 1,
            key: 'kedua',
            label: 'Laporan Kedua',
            berkases: this.lokakaryaBerkases.filter((s) => Number(s.k_lokakarya_berkas_psp) === 9) || [],
          },
        ],
        meetings: [
          {
            type: 'VTextField',
            name: 'url_meeting',
            label: 'Rekaman Video Conference taruh URL, video rekaman disini',
            labelColor: 'indigo',
            hint: '',
            required: true,
            grid: { cols: 12, md: 12, sm: 12 },
            outlined: true,
            singleLine: true,
            dense: true,
            readonly: this.readonly,
            prependInnerIcon: 'mdi-video',
          },
        ],
      };
    },
  },
};
